import { useState, useCallback, useRef } from "react";

const reactsArray = [
  {
    name: "like",
    image: "../../../reacts/like.gif",
  },
  {
    name: "love",
    image: "../../../reacts/love.gif",
  },
  {
    name: "haha",
    image: "../../../reacts/haha.gif",
  },
  {
    name: "wow",
    image: "../../../reacts/wow.gif",
  },
  {
    name: "sad",
    image: "../../../reacts/sad.gif",
  },
  {
    name: "angry",
    image: "../../../reacts/angry.gif",
  },
];

export default function ReactsPopup({ visible, setVisible, reactHandler }) {
  const [isProcessing, setIsProcessing] = useState(false);
  const processingRef = useRef(false);

  // Debounced handler para prevenir múltiplos cliques
  const handleReactClick = useCallback(
    (reactName) => {
      if (processingRef.current) {
        console.log("Reaction already processing, please wait...");
        return;
      }

      processingRef.current = true;
      setIsProcessing(true);

      // Chamar o handler original
      if (reactHandler) {
        reactHandler(reactName);
      }

      // Reset após 1 segundo
      setTimeout(() => {
        processingRef.current = false;
        setIsProcessing(false);
      }, 1000);
    },
    [reactHandler]
  );

  return (
    <>
      {visible && (
        <div
          className="reacts_popup"
          onMouseOver={() => {
            setTimeout(() => {
              setVisible(true);
            }, 500);
          }}
          onMouseLeave={() => {
            setTimeout(() => {
              setVisible(false);
            }, 500);
          }}
        >
          {reactsArray.map((react, i) => (
            <div
              className={`react ${isProcessing ? "processing" : ""}`}
              key={i}
              onClick={() => handleReactClick(react.name)}
              style={{
                cursor: isProcessing ? "wait" : "pointer",
                opacity: isProcessing ? 0.7 : 1,
              }}
            >
              <img src={react.image} alt={react.name} />
            </div>
          ))}
        </div>
      )}
    </>
  );
}
